import { render, staticRenderFns } from "./BookingCreate.vue?vue&type=template&id=318e9d07&scoped=true&"
import script from "./BookingCreate.vue?vue&type=script&lang=js&"
export * from "./BookingCreate.vue?vue&type=script&lang=js&"
import style0 from "./BookingCreate.vue?vue&type=style&index=0&id=318e9d07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318e9d07",
  null
  
)

export default component.exports